import React, { useState, useEffect } from "react";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import Pending from "../../../assets/images/iconFan/expired-1.png";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";
const AdminPendingFanGroup = () => {
  const [event_data, setFanPending] = useState([]);
  const [fanPendingCount, setFanPendingCount] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/fan/group/adminlist/status`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setFanPendingCount(res.data.fanPendingCount);
        setFanPending(res.data.fanPending);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Pending Fan Group"
        image={Pending}
        count={event_data.length}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          fan={"true"}
          urlLink={`/superstar-admin/pending-fan-group-Edit-delete`}
        />
      )}
    </>
  );
};

export default AdminPendingFanGroup;
